/** The CRM fee codes the order form keys off, since Efkt has no per-account invoicing permission. */
export const FEE_CODE = {
    keyPickup: 'FEE_KEY_STA',
    endUserInvoice: 'FEE_EBI_STA',
};
